module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-8-44e1ad6902140085038ef0c7a539e9e2.jpg";